import React, { useContext, useEffect, useState } from 'react';

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Button,
} from 'reactstrap';

import { ApiContext } from '../contexts/ApiContext';
import MenuService from '../service/menu.service';
import ItemForm from './Foods/ItemForm';
import './Foods/styles.css';
import ConfirmDeleteModal from 'components/ConfirmDeleteModal/ConfirmDeleteModal';
import { formatItemPrice } from '../utils/currency';
import RecipeModal from './Foods/RecipeModal';

const Foods = () => {
  const { account } = useContext(ApiContext);
  const menuCode = account && account.menuCode;

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showItemForm, setShowItemForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [activeCategoryId, setActiveCategoryId] = useState(null);

  const [toDelete, setToDelete] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [recipeItem, setRecipeItem] = useState(null);

  const fetchMenu = async () => {
    if (!menuCode) return;
    setLoading(true);
    try {
      const res = await MenuService.getMenu(menuCode);
      // res expected to be array of categories with items
      setCategories(res || []);
    } catch (e) {
      console.error('Erro ao buscar menu', e);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuCode]);

  const handleAddItem = (categoryId) => {
    setEditingItem(null);
    setActiveCategoryId(categoryId);
    setShowItemForm(true);
  };

  const handleEditItem = (item) => {
    setEditingItem(item);
    setActiveCategoryId(item.categoryId);
    setShowItemForm(true);
  };

  const handleDeleteItem = async (id) => {
    try {
      await MenuService.deleteMenuItem(id);
      fetchMenu();
    } catch (e) {
      console.error('Erro ao deletar item', e);
      if (e && e.status === 401) return alert('Não autorizado. Faça login novamente.');
      return alert('Erro ao deletar item');
    }
  };

  const confirmDeleteItem = (item) => {
    setToDelete(item);
    setShowDelete(true);
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="flex">
                <CardTitle tag="h4">Cardápio</CardTitle>
                {/* <Button
                  onClick={() => navigate(accountPath(account?.id, '/cardapio/adicionar'))}
                  className="btn-fill"
                  color="primary"
                >
                  Adicionar Item
                </Button> */}
              </CardHeader>
              <CardBody>
                {loading && <div>Carregando...</div>}

                {!loading && categories.length === 0 && (
                  <div>Nenhuma categoria encontrada.</div>
                )}

                {!loading && categories.map((cat) => (
                  <Card className="mb-3" key={cat.id}>
                    <CardHeader className="d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="mb-0">{cat.name}</h5>
                        <small className="text-muted">{cat.items ? cat.items.length : 0} itens</small>
                      </div>
                      <div>
                        <Button color="primary" size="sm" className="mr-2" onClick={() => handleAddItem(cat.id)}>Adicionar</Button>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <div className="foods-table-wrapper">
                        <Table className="tablesorter foods-table">
                          <thead className="text-primary">
                            <tr>
                              <th className="foods-col-name">Nome</th>
                              <th className="foods-col-desc">Descrição</th>
                              <th className="foods-col-price">Preço</th>
                              <th className="foods-col-status">Status</th>
                              <th className="foods-col-images">Imagens</th>
                              <th className="text-center foods-col-actions">Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                          {cat.items && cat.items.length > 0 ? cat.items.map((item) => (
                            <tr key={item.id}>
                              <td>{item.name}</td>
                              <td className="foods-col-desc">{item.description}</td>
                              <td className="foods-col-price">{formatItemPrice(item)}</td>
                              <td className="foods-col-status">{item.active ? <span className="status-active">●</span> : <span className="status-inactive">●</span>}</td>
                              {/* <td>
                                {item.variants && item.variants.length > 0 ? (
                                  item.variants.map(v => (
                                    <div key={v.id}>{v.name} (+R$ {(v.extraCents/100).toFixed(2)})</div>
                                  ))
                                ) : ('-')}
                              </td> */}
                              <td className="foods-col-images">
                                {item.images && item.images.length > 0 ? (
                                  item.images.map(img => (
                                    <img key={img.id} src={img.url} alt={item.name} style={{height:40, marginRight:6}} />
                                  ))
                                ) : ('-')}
                              </td>
                              <td className="text-center foods-col-actions">
                                <div className="foods-actions">
                                  {account?.inventoryEnabled && (
                                    <Button color="primary" size="sm" onClick={() => setRecipeItem(item)} title="Configurar ficha técnica">
                                      Ficha técnica
                                    </Button>
                                  )}
                                  <Button color="info" size="sm" className="btn-icon" onClick={() => handleEditItem(item)} title="Editar">
                                    <i className="tim-icons icon-pencil" />
                                  </Button>
                                  <Button color="danger" size="sm" className="btn-icon" onClick={() => confirmDeleteItem(item)} title="Excluir">
                                    <i className="tim-icons icon-trash-simple" />
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          )) : (
                            <tr className="foods-no-items">
                              <td colSpan={6} className="text-center text-muted">Nenhum item nesta categoria</td>
                            </tr>
                          )}
                        </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <ItemForm
        show={showItemForm}
        setShow={setShowItemForm}
        item={editingItem}
        categoryId={activeCategoryId}
        categoryItems={categories.find((c) => c.id === activeCategoryId)?.items}
        onSaved={fetchMenu}
      />

      <ConfirmDeleteModal
        isOpen={showDelete}
        toggle={() => setShowDelete(!showDelete)}
        message={toDelete ? `Deseja realmente excluir o item "${toDelete.name}"?` : 'Deseja realmente excluir?' }
        onConfirm={() => toDelete && handleDeleteItem(toDelete.id)}
      />

      <RecipeModal
        item={recipeItem}
        accountId={account?.id}
        isOpen={Boolean(recipeItem)}
        toggle={() => setRecipeItem(null)}
      />
    </>
  );
}

export default Foods;
